<template>
  <div class="news">
  <indexHd/>
   <div class="content">
    <div class="commonBg">
       <div class="wrapper">
         <div class="formBox">
           <div class="form">
             <div class="comtit">
               <h5>用户注册</h5>
                <span>已有账号？</span><router-link :to="{path:'/Login'}">立即登录</router-link>
              </div>
              <div class="inptBox">
                <label>手机号</label>
                <input v-model="phone" class="inpt" type="tel" placeholder="请输入手机号码" />
              </div>
              <div class="inptBox">
                <label>密码</label>
                <input v-model="password" class="inpt" :type="pwdType" placeholder="请输入密码" />
                <img class="isOpen" :src="see?noeyes:eyes" @click="changeType()"/>
              </div>
              <div class="inptBox">
                <label>确认密码</label>
                <input v-model="Rpassword" class="inpt" :type="RpwdType" placeholder="请输入确认密码" />
                <img class="isOpen" :src="Rsee?noeyes:eyes" @click="RchangeType()"/>
              </div>
              <div class="inptBox">
                <label>验证码</label>
                <input v-model="code" class="inpt" type="text" placeholder="请输入验证码" />
                <button class="getBtn" @click.prevent="getCode">
                  {{computeTime>0 ?`${computeTime}s` : '获取验证码'}}
                </button>
              </div>
              <div class="btnMod">
                <button class="btn" @click="checkRegister()">注册</button>
              </div>
              <div class="protocol">点击 [ 注册 ] 即表示您同意<span class="blue" @click="service">《服务协议》</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <foot />
    <agreement  ref="agreement"/>
  </div>
</template>
<script>

import eyes from '@/assets/img/eyes.png'
import noeyes from '@/assets/img/noeyes.png'
import indexHd from '@/components/indexHd.vue'
import foot from '@/components/foot.vue'
import agreement from '@/components/agreement.vue'
export default {
  name: 'Login',
  components: {
    foot,
    indexHd,
    agreement
  },
  data () {
    return {
      eyes,
      noeyes,
      pwdType: 'password',
      RpwdType: 'password',
      Rsee: '',
      see: '',
      phone: '',
      password: '',
      Rpassword: '',
      code: '',
      computeTime: ''
    }
  },
  created () {},
  methods: {
    // 打开服务条例
    service() {
     this.$refs.agreement.agreementShow =true
    },
    // 控制是否显示密码
    RchangeType () {
      this.RpwdType = this.RpwdType === 'password' ? 'text' : 'password'
      this.Rsee = !this.Rsee
    },
    changeType () {
      this.pwdType = this.pwdType === 'password' ? 'text' : 'password'
      this.see = !this.see
    },
    // 获取验证码
    getCode () {
      // 发送验证码前进行判断
       if(this.phone === '') {
        this.$alert('请填写手机号')
        return
      }if(!(/^1[3456789]\d{9}$/.test(this.phone))) {
         this.$alert('手机号格式不对')
         return
      }
      // 如果没有倒计时
      if (!this.computeTime) {
        // 启动倒计时
        this.computeTime = 60
        var initVal = setInterval(() => {
          this.computeTime--
          if (this.computeTime <= 0) { // 清除定时器
            clearInterval(initVal)
          }
        }, 1000)
        console.log('发送验证码')
        const iphone = { phone: this.phone }
        this.$api.getMessageCode(iphone).then(response => {
          console.log(response)
        })
      }
    },
    // 确认注册
    checkRegister () {
      // 表单验证
      if (!(/^1[3456789]\d{9}$/.test(this.phone))) {
        this.$alert('手机号码格式错误')
        return
      }
      if (this.Rpassword !== this.password) {
        this.$alert('两次密码要相同')
        return
      } if (this.password === '' || this.phone === '') {
        this.$alert('手机号或密码不能为空')
        return
      } if (this.code === '') {
        this.$alert('验证码不能为空')
        return
      }
      // 注册成功实现
      const params = { phone: this.phone, name: this.phone, password: this.password, smsCode: this.code }
      this.$api.getMemberRegister(params).then(response => {
        if (response.code === 200) {
          this.$alert('注册成功')
          this.$router.push({ path: '/Login' })
          localStorage.setItem('phone', this.phone)
          localStorage.setItem('password', this.password)
        } else {
          this.$alert(response.msg)
        }
      })
    }

  }
}
</script>
<style scoped lang="scss">

</style>
